import { z } from "zod";
import { addressSchema } from "./address.js";
import { paginatedResponseSchema } from "../pagination.js";
export const householdInputSchema = z.object({
    displayNameCustom: z.string().nullable().optional(),
    address: addressSchema.optional(),
});
export const householdMembershipPatchSchema = z
    .object({
    add: z.array(z.string()).optional(),
    remove: z.array(z.string()).optional(),
})
    .optional();
export const householdPatchSchema = householdInputSchema.partial().extend({
    members: householdMembershipPatchSchema,
});
export const householdSchema = householdInputSchema.extend({
    id: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const householdMemberSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
});
export const householdDetailSchema = householdSchema.extend({
    members: z.array(householdMemberSchema),
    memberCount: z.number().int().nonnegative(),
});
export const householdListItemSchema = householdSchema.extend({
    memberCount: z.number().int().nonnegative(),
});
export const householdListResponseSchema = paginatedResponseSchema(householdListItemSchema);
//# sourceMappingURL=household.js.map